import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlickSliderComponent } from './slick-slider.component';
import { SkeletonLoaderModule } from 'src/app/modules/tenders/_modals/SkeletonLoader/skeleton-loader.module';
import { NumberFormatterPipesModule } from '../../_pipes/number-formatter.pipe.module';
import { LazyLoadModule } from './../../../tenders/_components/tenders/lazy-load.module';

@NgModule({
    declarations: [SlickSliderComponent],
    imports: [CommonModule,
        SkeletonLoaderModule, LazyLoadModule, NumberFormatterPipesModule
    ],
    exports: [SlickSliderComponent]
})
export class SlickSliderModule { }